import * as Types from '../redux/actionTypes';

function groupByUser(items) {
  const checkins = {};

  items.forEach((item) => {
    if (!checkins[item.user.id]) {
      checkins[item.user.id] = [];
    }
     checkins[item.user.id].push(item);
  });
  return checkins;
}

function userCheckin(state = createInitState(), action) {
  switch (action.type) {
    case Types.USER_CHECKINS_LIST_GET:
      return {
        ...state,
        query: {...action.payload},
        isFetching: true
      };
    case Types.USER_CHECKINS_LIST_GET_SUCCESS:
      return {
        ...state,
        isFetching: false,
        items: action.payload.results,
        groupByUser: groupByUser(action.payload.results)
      };
    case Types.USER_CHECKINS_LIST_GET_FAILURE:
      return {
        ...state,
        isFetching: false
      };
    default:
      return state;
  }
}

function createInitState() {
  return {
    isFetching: false,
    query: createInitSettings(),
    items: [],
    groupByUser: {},
  };
}

function createInitSettings() {
  return {
    page: null,
    expand: null,
  };
}


export default userCheckin;



// WEBPACK FOOTER //
// ./shared/checkins/redux/reducers.js